import Cookies from "js-cookie";
import { logout } from "../ApiCalls/authentication";

// L-01 (MA-06): the JWT now lives in an httpOnly cookie the backend sets/clears —
// this is the one HTTP chokepoint most ApiCalls/*.js files go through, so fixing
// cookie transport + CSRF here covers all of them without touching each file.
const MUTATING_METHODS = new Set(["POST", "PUT", "PATCH", "DELETE"]);

export async function fetchWrapper(url, options = {}, timeout = 60000) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);
  const method = (options.method || "GET").toUpperCase();
  const headers = { ...(options.headers || {}) };
  
  // Clean up any case-insensitive duplicate headers to prevent sending the token twice
  for (const key of Object.keys(headers)) {
    if (key.toLowerCase() === "x-csrf-token") {
      delete headers[key];
    }
  }

  if (MUTATING_METHODS.has(method)) {
    const csrfToken = Cookies.get("csrfToken");
    if (csrfToken) headers["X-CSRF-Token"] = csrfToken;
  }
  try {
    const response = await fetch(url, {
      ...options,
      headers,
      credentials: "include",
      signal: controller.signal,
    });

    if (response.status === 401) {
      handleSessionExpiration();
      return;
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error en fetchWrapper:", error);
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
}

function handleSessionExpiration() {
  localStorage.setItem("sessionExpired", true);
  window.location.href = '/';
  logout();
}